import { Language } from '@/ifaces/language';
import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '@/clients/util/xhr';
import { useAuthedUserContext } from '@/clients/shared-hooks/use-authed-user';

export const useLanguages = () => {
  const authed = useAuthedUserContext();
  const showDisabledLanguages = authed.customer?.showDisabledLanguages;
  const { data: languages } = useQuery<Language[]>({
    queryKey: ['languages'],
    queryFn: () => fetchJson('api/languages'),
  });

  return {
    languages: languages
      ?.filter((language) => showDisabledLanguages || language.enabled)
      .sort((a, b) => a.name.localeCompare(b.name)),
  };
};
